export default {
  'processPortal.title': 'Gestionar Portal de Procesos',

  'processPortal.form.shortenedUrl': 'Url Abreviada',
  'processPortal.form.openUrl': 'Abrir Url',
  'processPortal.form.shortCode': 'ShortCode',

  'processPortal.descriptionProcess': 'Los procesos que van a aparecer en el portal',
  'processPortal.descriptionReport': 'Los reportes que van a aparecer en el portal',
  'processPortal.descriptionPermission': 'Los permisos de acceso al portal',
  'processPortal.descriptionList': 'Las listas que van a aparecer en el portal',
  'processPortal.descriptionEntity': 'Las entidades que van a aparecer en el portal',
  'processPortal.descriptionMenu': 'Estructura del menú para el portal de proceso',
  'processPortal.descriptionProcessWithName':
    'Los procesos que van a aparecer en el portal {name}.',
  'processPortal.descriptionReportWithName': 'Los reportes que van a aparecer en el portal {name}.',
  'processPortal.descriptionListWithName': 'Las listas que van a aparecer en el portal {name}.',
  'processPortal.descriptionEntityWithName':
    'Las entidades que van a aparecer en el portal {name}.',

  'processPortal.configurations.description':
    'Elija una sección para configurar contenido y acceso de este portal de procesos.',
  'processPortal.configurations.descriptionWithName':
    'Elija una sección para configurar contenido y acceso de {name}.',
  'processPortal.permissions.description':
    'Agregue o quite quién puede acceder al portal de procesos {name}.',
  'processPortal.menu.descriptionWithName':
    'Configure la estructura del menú para el portal de procesos {name}.',

  'processPortal.form.mainColor': 'Color Principal',
  'processPortal.form.logoUrl': 'Logo (Url)',
  'processPortal.form.template': 'Plantilla',
  'processPortal.form.loginSplashUrl': 'Inicio de Sesión (Url)',
  'processPortal.form.fontUrl': 'Fuente (Url)',
  'processPortal.form.iconLogoUrl': 'Icono (Url)',
  'processPortal.form.faviconUrl': 'Favicon (Url)',
  'processPortal.form.permissionsFiltersLogicalOperator': 'Operador Lógico de Filtros de Permisos',
  'processPortal.form.hideMenuItemHome': 'Ocultar menú Inicio',
  'processPortal.form.hideMenuItemTasks': 'Ocultar menú Tareas',
  'processPortal.form.hideMenuItemRequests': 'Ocultar menú Solicitudes',

  'processPortal.menu.customList': 'Lista',
  'processPortal.menu.customLists': 'Todas las Listas',
  'processPortal.menu.dynamicEntity': 'Entidad Dinámica',
  'processPortal.menu.dynamicEntities': 'Todas las Entidades Dinámicas',
  'processPortal.menu.report': 'Reporte',
  'processPortal.menu.reports': 'Todos los Reportes',
  'processPortal.menu.process': 'Proceso',
  'processPortal.menu.processes': 'Todos los Procesos',
  'processPortal.menu.link': 'Enlace',
  'processPortal.menu.subMenu': 'Menú Desplegable',
  'processPortal.menu.embedHtml': 'HTML Incrustado',
  'processPortal.menu.renderTemplate': 'Renderizar Plantilla',
  'processPortal.menu.parentSubMenu': 'Sub Menú Padre',
  'processPortal.menu.htmlFile': 'Archivo HTML',
  'processPortal.menu.templateLink': 'URL de Plantilla',
  'processPortal.menu.preview': 'Vista Previa',

  'processPortal.action.generatePublicUrl': 'Generar URL Pública',
  'processPortal.action.deactivatePublicUrl': 'Desactivar URL Pública',
};
